module.exports = __webpack_public_path__ + "img/tips.d0445b12.jpg";